import { PlaneObservation } from 'services/adsb/dto';
import {
  SocketData,
  MESSAGE_TYPE,
  ADSBPositions,
  DEFAULT_VIEW_DATA,
  AIRCRAFTS_VIEW_DATA,
  AircraftView,
  AircraftColor,
} from './models';

const getPlaneColor = (verticalRate : number) : string => {
  let planeColor;

  if (verticalRate < -250) {
    planeColor = AircraftColor.ORANGE;
  } else if (verticalRate > 250) {
    planeColor = AircraftColor.BLUE;
  } else {
    planeColor = AircraftColor.GRAY;
  }

  return planeColor;
};

const getLabelText = (position: ADSBPositions) : string => `${position.flight ? position.flight : 'n/a'}`;

const getExtendedLabelText = (position: ADSBPositions) : string => `${position.flight || 'n/a'},${position.origin || 'n/a'}→${position.destination || 'n/a'},Type: ${position.type || 'n/a'}, Altitude: ${`${position.altitude} ft` || 'n/a'}, Speed: ${`${position.speed} kt` || 'n/a'}`;

const getAircraftViewData = (position: ADSBPositions) : AircraftView => {
  const {
    category, source,
  } = position;
  const viewData = {
    ...AIRCRAFTS_VIEW_DATA
      .find((item) => item.source === source && item.category === category)
    || { ...DEFAULT_VIEW_DATA },
  };

  viewData.label = getLabelText(position);
  viewData.extendedLabel = getExtendedLabelText(position);
  viewData.color = getPlaneColor(position.verticalRate);
  /* If plane size is going to get changed, .svg file size should also be changed */
  // viewData.size = altitude > 1000 ? 30 : 20;
  viewData.size = 30;

  return viewData;
};

const degreesToRadians = (degrees: number) : number => degrees * (Math.PI / 180);

const extractADSBPosition = (position: any): ADSBPositions => {
  const adsbPosition: ADSBPositions = {
    longitude: position.lon,
    latitude: position.lat,
    icaocode: position.hex,
    time: position.uti,
    direction: degreesToRadians(position.trk),
    altitude: position.alt,
    gda: position.gda,
    ageLastPosition: position.lla,
    origin: position.org,
    destination: position.dst,
    alerts: position.alr,
    source: position.src,
    category: position.cat,
    modeS: position.hex,
    flight: position.fli,
    registration: position.reg,
    verticalRate: position.vrt,
    speed: position.spd,
    type: position.typ,
    squawk: position.squ,
  };

  adsbPosition.viewData = getAircraftViewData(adsbPosition);

  return adsbPosition;
};

const extractPositions = (input: any[])
  : ADSBPositions[] => input.map((position) => extractADSBPosition(position));

const parseADSBMessage = (data: SocketData)
  : ADSBPositions[] => extractPositions(data.message);

const parseErrorMessage = (data: SocketData)
  : string => data.message[0];

export const parsePlaneData = (data: PlaneObservation)
  : ADSBPositions[] => extractPositions(data.planes);

const parseMessage = (data: SocketData) : any => {
  try {
    if (data.type === MESSAGE_TYPE.ADS_B) {
      return parseADSBMessage(data);
    }
    if (data.type === MESSAGE_TYPE.ADSB_CONNECTION_ERROR) {
      return parseErrorMessage(data);
    }

    return true;
  } catch (exception) {
    return false;
  }
};

export default parseMessage;
